import PromoNewItemInterface from 'app/interfaces/articles/PromoNewItemInterface';

export type PromoNewPromoType = PromoNewItemInterface['promo_type'];

const PROMO_NEW_PROMO_TYPES = [
    'bets',
    'casino',
    'permanent'
] as const satisfies readonly PromoNewPromoType[];

export const PROMO_NEW_FILTER_TABS = ['all', ...PROMO_NEW_PROMO_TYPES] as const;

export type PromoNewFilterType = typeof PROMO_NEW_FILTER_TABS[number];

export const PROMO_NEW_SORT_OPTIONS = [
    'ending_soon',
    'recently_added',
    'popular'
] as const;

export type PromoNewSortType = typeof PROMO_NEW_SORT_OPTIONS[number];

type PromoNewSortComparator = (a: PromoNewItemInterface, b: PromoNewItemInterface) => number;

const compareByEndingSoon: PromoNewSortComparator = (a, b) => {
    const aHasEnd = a.ended_at === null;
    const bHasEnd = b.ended_at === null;

    if (aHasEnd !== bHasEnd) {
        return Number(aHasEnd) - Number(bHasEnd);
    }

    if (!a.ended_at || !b.ended_at) {
        return 0;
    }

    return a.ended_at - b.ended_at;
};

const SORT_COMPARATORS: Record<PromoNewSortType, PromoNewSortComparator> = {
    ending_soon: compareByEndingSoon,
    popular: (a, b) => (b.participants_count ?? 0) - (a.participants_count ?? 0),
    recently_added: (a, b) => (b.created_at ?? 0) - (a.created_at ?? 0)
};

export const filterPromoNewItems = (
    items: PromoNewItemInterface[],
    filterType: PromoNewFilterType
): PromoNewItemInterface[] => {
    if (filterType === 'all') {
        return items;
    }

    return items.filter(item => item.promo_type === filterType);
};

export const sortPromoNewItems = (
    items: PromoNewItemInterface[],
    sortType: PromoNewSortType
): PromoNewItemInterface[] => [...items].sort(SORT_COMPARATORS[sortType]);

export const getFilteredAndSortedPromoNewItems = (
    items: PromoNewItemInterface[],
    filterType: PromoNewFilterType,
    sortType: PromoNewSortType
): PromoNewItemInterface[] => sortPromoNewItems(filterPromoNewItems(items, filterType), sortType);
